import React from 'react';
import { useTheme } from '@mui/material';

interface Props {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: any;
  direction?: 'row' | 'column';
}

const FlexFormContainer = ({ children, onSubmit, direction }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <form
      noValidate
      onSubmit={onSubmit}
      style={{
        display: 'flex',
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        flexDirection: direction ? direction : 'column',
      }}
    >
      {children}
    </form>
  );
};

export default FlexFormContainer;
